// src/api/formation.js — Récupère les détails complets d'une formation via Xano

import { api } from "../lib/apiClient";

/**
 * @param {string} edumapperId - objectID Algolia de la formation
 * @returns {Promise<object|null>}
 */
export async function fetchFormation(edumapperId) {
  try {
    const { data } = await api.get(`/formations/${edumapperId}`);
    return data.formation ?? null;
  } catch {
    return null;
  }
}
